import { App, notification as notificationNative } from 'antd';
import { NotificationInstance } from 'antd/es/notification/interface';
import { ArgsType } from '../../global';
import { useEffect } from 'react';

// 全局单例 api
let notificationInstance: ReturnType<(typeof App)['useApp']>['notification'];
let readyResolve: ((api: typeof notificationInstance) => void) | null = null;
const readyPromise: Promise<typeof notificationInstance> = new Promise(res => {
  readyResolve = res;
});

export const NotificationHolder = () => {
  const { notification } = App.useApp();
  useEffect(() => {
    notificationInstance = notification;
    // resolve 等待者
    readyResolve?.(notification);
    return () => {
      notificationInstance = null;
    };
  }, [notification]);
  return <></>;
};

const mkFn = <T extends (...args: any) => any>(method: string) => {
  return (...args: ArgsType<T>) => {
    return notificationInstance[method](...args) as ReturnType<T>;
  };
};

export const notification = {
  info: mkFn<NotificationInstance['info']>('info'),
  success: mkFn<NotificationInstance['success']>('success'),
  error: mkFn<NotificationInstance['error']>('error'),
  warning: mkFn<NotificationInstance['warning']>('warning'),
  open: mkFn<NotificationInstance['open']>('open'),
  destroy: mkFn<NotificationInstance['destroy']>('destroy'),
  config: notificationNative.config,
};
